/**
 * Lets a page-level component claim responsibility for flipping
 * `window.prerenderReady` so that Layout's own effect doesn't fire prematurely.
 *
 * Why: Layout flips `prerenderReady = true` as soon as its own
 * `GET_MEMBER_LAYOUT_INFO` query resolves, but that ignores the wrapped page's
 * data fetches. Pages with their own loading states call `usePrerenderReady`,
 * which takes ownership here and prevents Layout's flip until the page itself
 * signals ready.
 */

let pageOwns = false;

export const takePrerenderReadyOwnership = () => {
  pageOwns = true;
  return () => {
    pageOwns = false;
  };
};

export const pageOwnsPrerenderReady = () => pageOwns;
